import { useChatStatus } from '@/features/chat/chat-api';

/**
 * What the sidebar needs to know about chat: whether to show the link at all,
 * and how many conversations are waiting.
 *
 * Its own module beside `use-pending-badges` so the sidebar's tests can stand
 * it in the same way — the hook underneath polls, and a sidebar rendered in a
 * test should not be firing requests.
 */
export function useChatNav(): { enabled: boolean; unread: number } {
  return useChatStatus();
}
